<div class="sg-background-host">
  <div class="error-background sg-flex-column">
    <div class="close-button-container">
      <sg-button variant="ghost-secondary" icon="close" mat-dialog-close></sg-button>
    </div>
    <div class="error-content sg-flex-column sg-justify-center sg-items-center">
      <mat-icon class="sg-icon">sg-error</mat-icon>
      <h1 translate>ERROR.title</h1>
      <h3 translate class="error-message">ERROR.desc</h3>
      <sg-button variant="primary" mat-dialog-close [text]="'ERROR.action' | translate"></sg-button>
    </div>
  </div>
</div>
